import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { Grid, IconButton } from '@material-ui/core';
import { useTranslation } from '../../../src/i18n';
import { TP } from '../../../constants/consts';
import Button from '../../Button';
import EditIcon from '../../Icons/EditIcon';
import PublicPrivateSwitcher from '../../PublicPrivateSwitcher';
import DeleteFbIcon from '../../Icons/DeleteFbIcon';
import TextButton from '../../TextButton';

const useStyles = makeStyles(() => ({
  buttonsBlock: {
    width: 'auto',
  },
  editButton: {
    wordBreak: 'break-word',
  },
}));

const EditCardButtons = ({
  className,
  editClick,
  visibilityClick,
  editButtonName,
  privacyOptions,
  value,
  onDelete,
  deleteButtonText,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Grid container spacing={2} className={cn(className, classes.buttonsBlock)} alignItems="center" justify="center">
      {visibilityClick && (
        <Grid item>
          <PublicPrivateSwitcher onChange={v => visibilityClick(v)} options={privacyOptions} value={value} />
        </Grid>
      )}
      <Grid item>
        <Button color="default" startIcon={<EditIcon />} onClick={editClick} className={classes.editButton}>
          {t(editButtonName)}
        </Button>
      </Grid>
      {onDelete && (
        <Grid item>
          {deleteButtonText ? (
            <TextButton onClick={onDelete} startIcon={<DeleteFbIcon />}>
              {deleteButtonText}
            </TextButton>
          ) : (
            <IconButton onClick={onDelete}>
              <DeleteFbIcon />
            </IconButton>
          )}
        </Grid>
      )}
    </Grid>
  );
};

EditCardButtons.propTypes = {
  className: PropTypes.string,
  editClick: PropTypes.func.isRequired,
  visibilityClick: PropTypes.func,
  editButtonName: PropTypes.string,
  value: PropTypes.object,
  privacyOptions: PropTypes.array,
  deleteButtonText: PropTypes.string,
};

EditCardButtons.defaultProps = {
  editButtonName: `${TP}.FN_ADD_DETAILS`,
  privacyOptions: [],
  visibilityClick: undefined,
  deleteButtonText: '',
};

export default memo(EditCardButtons);
